import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade, NotificationFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-customer-account-change-email',
    templateUrl: './customer-account-change-email.component.html',
    styleUrls: ['./customer-account-change-email.component.scss']
})
export class CustomerAccountChangeEmailComponent extends BaseComponent implements OnInit, OnDestroy {
    @Output() onSubmitEmail = new EventEmitter<any>();

    _emailForm: FormGroup;

    constructor(
        private customerFacade: CustomerFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this._emailForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });

        this.customerFacade.error$.pipe(takeUntil(this.componentDestroyed$)).subscribe((error) => {
            if (error) {
                this.handleError(error);
            }
        });
    }

    submitForm() {
        if (this._emailForm.valid) {
            const email = this._emailForm.value.email;
            this.customerFacade.sendCustomerNewEmail(email);
            this.onSubmitEmail.emit(email);
        }
    }

    handleError(e: any) {
        if (e.error.error) {
            this.notification.error(this.translate.instant(e.error.error));
        } else {
            this.notification.error(this.translate.instant(e.error));
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
